trailingCode